import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Appt } from '../../models/contact-modal/appt.model';
import { CAScreenDisplayFilterResponse, CustomActionScreen } from '../../models/contact-modal/customAction.model';
import { eApptStatus, eLiveConnectCheckedInMethod, eLiveConnectCLPUserStatus, eLiveConnectItemActionStatus } from '../../models/contact-modal/enum.model';
import { IntDropDownItem, SimpleResponse } from '../../models/contact-modal/genericResponse.model';
import { LiveConnectItem } from '../../models/contact-modal/live-connect-item.model';
import { ActivityReportResponse, ActivitySummaryRequest, ActivitySummaryResponse, AssginedUsers, CheckedInStatusResponse, CheckInStatusSetupResponse, CheckStatusResponse, ContactArchive, GBC_UserListResponse, InCallSummary, LCCheckedInRequest, LCResponseTime, LCVoiceCallResponse, LiveConnectAccountResponse, LiveConnectCLPUserResponse, LiveConnectContactObj, LiveConnectContactResponse, LiveConnectDashHeaderResponse, LiveConnectDashLoadRequest, LiveConnectDashLoadResponse, LiveConnectDealsResponse, LiveConnectHeaderResponse, LiveConnectItemResponse, LiveConnectMakeVCLoadResponse, LiveConnectSettingResponse, LiveConnectt, LiveConnectTxtmsgIBLoadResponse, OpenAiResponse, ResponseTimeSetup, EngageCTeamResponse, TxtMessage, VoiceCallConnect, EmailBox, EmailBoxResponse, EmailBoxSuppressListResponse, EmailBoxSuppress } from '../../models/contact-modal/live-connect.model';
import { ResponseTimeDataResponse, TxtMsgIBResponse } from '../../models/contact-modal/report.model';
import { delayedRetryHttp } from './shared/delayedRetry';
import { UtilityService } from './shared/utility.service';

@Injectable()
export class LiveConnectService {
    private baseUrl: string;
    private baseUrlEmailBox: string;
    private api: string = "api/Engage/LiveConnect";
    private apiEmailBox: string = "api/Engage/EmailBox";

    constructor(private httpClient: HttpClient, @Inject('BASE_URL') _baseUrl: string, private _utilityService: UtilityService) {
        this.baseUrl = _baseUrl + this.api;
        this.baseUrlEmailBox = _baseUrl + this.apiEmailBox;
    }

    async contactOptOutOptIn(encryptedUser: string, loggedInCLPUserID: number, liveConnectClpuserID: number, contactID: number, isOptOut: boolean): Promise<SimpleResponse | void> {
        const a = await this.httpClient.get<SimpleResponse>(`${this.baseUrl}/CTOptOutOptIn/${loggedInCLPUserID}/${liveConnectClpuserID}/${contactID}/${isOptOut}`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + encryptedUser
            })
        }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + " , " + "loggedInCLPUserID - " + loggedInCLPUserID + " , " + "liveConnectClpuserID - " + liveConnectClpuserID + " , " + "contactID - " + contactID + " , " + "isOptOut - " + isOptOut, encryptedUser, "LiveConnectService", "contactOptOutOptIn") });
        return a;
    }

    async liveConnect_isLiveConnectSRSAccount(encryptedUser: string, clpCompanyId: number): Promise<SimpleResponse | void> {
        const a = await this.httpClient.get<SimpleResponse>(`${this.baseUrl}/LiveConnect_isLiveConnectSRSAccount/${clpCompanyId}`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + encryptedUser
            })
        }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + " , " + "clpCompanyId - " + clpCompanyId, encryptedUser, "LiveConnectService", "liveConnect_isLiveConnectSRSAccount") });
        return a;
    }

    async IsLiveConnectCLPUser(encryptedUser: string, liveConnectCLPUserID: number): Promise<SimpleResponse | void> {
        const a = await this.httpClient.get<SimpleResponse>(`${this.baseUrl}/IsLiveConnectCLPUser/${liveConnectCLPUserID}`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + encryptedUser
            })
        }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + " , " + "liveConnectCLPUserID - " + liveConnectCLPUserID, encryptedUser, "LiveConnectService", "IsLiveConnectCLPUser") });
        return a;
    }

    async liveConnectSettingcbStatus(encryptedUser: string, clpUserID: number, liveConnectID: number, isStatus: number): Promise<SimpleResponse | void> {
        const a = await this.httpClient.get<SimpleResponse>(`${this.baseUrl}/LiveConnectSettingcbStatus/${clpUserID}/${liveConnectID}/${isStatus}`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + encryptedUser
            })
        }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + " , " + "clpUserID - " + clpUserID + " , " + "liveConnectID - " + liveConnectID + " , " + "isStatus - " + isStatus, encryptedUser, "LiveConnectService", "liveConnectSettingcbStatus") });
        return a;
    }


    async liveConnect_LoadByUser(encryptedUser: string, clpUserId: number): Promise<LiveConnectt | void> {
        const a = await this.httpClient.get<LiveConnectt>(`${this.baseUrl}/LiveConnect_LoadByUser/${clpUserId}`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + encryptedUser
            })
        }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + " , " + "clpUserId - " + clpUserId, encryptedUser, "LiveConnectService", "LiveConnect_LoadByUser") });
        return a;
    }

    async liveConnectSave(encryptedUser: string, liveConnecttObj: LiveConnectt): Promise<SimpleResponse | void> {
        const a = await this.httpClient.post<SimpleResponse>(`${this.baseUrl}/LiveConnect_Save`, liveConnecttObj, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + encryptedUser
            })
        }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, liveConnecttObj, "r - " + encryptedUser, encryptedUser, "LiveConnectService", "liveConnectSave") });
        return a;
    }

    async liveConnectCLPUser_GetNewUserList(encryptedUser: string, liveConnectId: number, clpCompanyId: number, teamCode: number, officeCode: number): Promise<IntDropDownItem[] | void> {
        const a = await this.httpClient.get<IntDropDownItem[]>(`${this.baseUrl}/LiveConnectCLPUser_GetNewUserList/${liveConnectId}/${clpCompanyId}/${teamCode}/${officeCode}`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + encryptedUser
            })
        }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + " , " + "liveConnectId - " + liveConnectId + " , " + "clpCompanyId - " + clpCompanyId + " , " + "teamCode - " + teamCode + " , " + "officeCode - " + officeCode, encryptedUser, "LiveConnectService", "liveConnectCLPUser_GetNewUserList") });
        return a;
    }

    async liveConnectCLPUser_GetUserList(encryptedUser: string, liveConnectId: number, isMultiRing: string, isOverFlowRing: string, isSrs: string, eStatus: eLiveConnectCLPUserStatus): Promise<LiveConnectCLPUserResponse | void> {
        const a = await this.httpClient.get<LiveConnectCLPUserResponse>(`${this.baseUrl}/LiveConnectCLPUser_GetUserList/${liveConnectId}?isMultiRing=${isMultiRing}&isOverFlowRing=${isOverFlowRing}&isSrs=${isSrs}&eStatus=${eStatus}`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + encryptedUser
            })
        }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + " , " + "liveConnectId - " + liveConnectId + " , " + "isMultiRing - " + isMultiRing + " , " + "isOverFlowRing - " + isOverFlowRing + " , " + "isSrs - " + isSrs + " , " + "eStatus - " + eStatus, encryptedUser, "LiveConnectService", "liveConnectCLPUser_GetUserList") });
        return a;
    }

    async lcSettingUsersSave(encryptedUser: string, request: AssginedUsers[]): Promise<SimpleResponse | void> {
        const a = await this.httpClient.post<SimpleResponse>(`${this.baseUrl}/LCSettingUsersSave`, request, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + encryptedUser
            })
        }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "LiveConnectService", "lcSettingUsersSave") });
        return a;
    }

    async lcSettingAddLiveConnectCLPUser(encryptedUser: string, liveConnectID: number, liveConnectCLPUser: number, estat: eLiveConnectCLPUserStatus, isSRS: boolean): Promise<SimpleResponse | void> {
        const a = await this.httpClient.get<SimpleResponse>(`${this.baseUrl}/LCSettingAddLiveConnectCLPUser/${liveConnectID}/${liveConnectCLPUser}/${estat}/${isSRS}`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + encryptedUser
            })
        }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + " , " + "liveConnectID - " + liveConnectID + " , " + "liveConnectCLPUser - " + liveConnectCLPUser + " , " + "estat - " + estat + " , " + "isSRS - " + isSRS, encryptedUser, "LiveConnectService", "lcSettingAddLiveConnectCLPUser") });
        return a;
    }

    async liveConnectSettingisSRSActive(encryptedUser: string, clpUserID: number, liveConnectID: number, isSRSActive: number): Promise<SimpleResponse | void> {
        const a = await this.httpClient.get<SimpleResponse>(`${this.baseUrl}/LiveConnectSettingisSRSActive/${clpUserID}/${liveConnectID}/${isSRSActive}`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + encryptedUser
            })
        }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + " , " + "clpUserID - " + clpUserID + " , " + "liveConnectID - " + liveConnectID + " , " + "isSRSActive - " + isSRSActive, encryptedUser, "LiveConnectService", "liveConnectSettingisSRSActive") });
        return a;
    }

    async liveConnectSettingSRSSave(encryptedUser: string, clpUserID: number, liveconnectID: number, SRSCLPCompanyID: number): Promise<SimpleResponse | void> {
        const a = await this.httpClient.get<SimpleResponse>(`${this.baseUrl}/LiveConnectSettingSRSSave/${clpUserID}/${liveconnectID}/${SRSCLPCompanyID}`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + encryptedUser
            })
        }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + " , " + "clpUserID - " + clpUserID + " , " + "liveconnectID - " + liveconnectID + " , " + "SRSCLPCompanyID - " + SRSCLPCompanyID, encryptedUser, "LiveConnectService", "liveConnectSettingSRSSave") });
        return a;
    }

    async liveConnectSettingView(encryptedUser: string, checkedInRequest: LCCheckedInRequest): Promise<LiveConnectSettingResponse | void> {
        const a = await this.httpClient.post<LiveConnectSettingResponse>(`${this.baseUrl}/LiveConnectSettingView`, checkedInRequest, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + encryptedUser
            })
        }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, checkedInRequest, "r - " + encryptedUser, encryptedUser, "LiveConnectService", "liveConnectSettingView") });
        return a;
    }

    async emailBox_Create(encryptedUser: string, emailBox: EmailBox): Promise<SimpleResponse | void> {
        const a = await this.httpClient.post<SimpleResponse>(`${this.baseUrl}/EmailBox_Create`, emailBox, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + encryptedUser
            })
        }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, emailBox, "r - " + encryptedUser, encryptedUser, "LiveConnectService", "emailBox_Create") });
        return a;
    }

    async emailBox_Load(encryptedUser: string, emailBoxID: number): Promise<EmailBoxResponse | void> {
        const a = await this.httpClient.get<EmailBoxResponse>(`${this.baseUrl}/EmailBox_Load/${emailBoxID}`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + encryptedUser
            })
        }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + " , " + "emailBoxID - " + emailBoxID, encryptedUser, "LiveConnectService", "emailBox_Load") });
        return a;
    }

    async emailBox_LoadByCLPUser(encryptedUser: string, emailBoxID: number): Promise<EmailBoxResponse | void> {
        const a = await this.httpClient.get<EmailBoxResponse>(`${this.baseUrl}/EmailBox_LoadByCLPUser/${emailBoxID}`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + encryptedUser
            })
        }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + " , " + "emailBoxID - " + emailBoxID, encryptedUser, "LiveConnectService", "emailBox_LoadByCLPUser") });
        return a;
    }

    async emailBox_Save(encryptedUser: string, emailBox: EmailBox): Promise<SimpleResponse | void> {
        const a = await this.httpClient.post<SimpleResponse>(`${this.baseUrl}/EmailBox_Save`, emailBox, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + encryptedUser
            })
        }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, emailBox, "r - " + encryptedUser, encryptedUser, "LiveConnectService", "emailBox_Save") });
        return a;
    }

    async emailBox_Delete(encryptedUser: string, emailBoxID: number): Promise<SimpleResponse | void> {
        const a = await this.httpClient.get<SimpleResponse>(`${this.baseUrl}/EmailBox_Delete/${emailBoxID}`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + encryptedUser
            })
        }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + " , " + "emailBoxID - " + emailBoxID, encryptedUser, "LiveConnectService", "emailBox_Delete") });
        return a;
    }

    async emailBox_Connect(encryptedUser: string, emailBox: EmailBox): Promise<SimpleResponse | void> {
        const a = await this.httpClient.post<SimpleResponse>(`${this.baseUrl}/EmailBox_Connect`, emailBox, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + encryptedUser
            })
        }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, emailBox, "r - " + encryptedUser, encryptedUser, "LiveConnectService", "emailBox_Connect") });
        return a;
    }

    async emailBoxSuppress_GetList(encryptedUser: string, intEmailBoxID :number, strblnDomains :string= ""): Promise<EmailBoxSuppressListResponse | void> {
        const a = await this.httpClient.get<EmailBoxSuppressListResponse>(`${this.baseUrlEmailBox}/EmailBoxSuppress_GetList?intEmailBoxID=${intEmailBoxID}&strblnDomains=${strblnDomains}`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + encryptedUser
            })
        }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, "r - " + encryptedUser, encryptedUser, "LiveConnectService", "emailBoxSuppress_GetList") });
        return a;
    }

    async emailBoxSuppress_ClearList(encryptedUser: string, emailBoxID : number, blnSuppressDomain : boolean): Promise<SimpleResponse | void> {
        const a = await this.httpClient.get<SimpleResponse>(`${this.baseUrlEmailBox}/EmailBoxSuppress_ClearList/${emailBoxID}/${blnSuppressDomain}`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + encryptedUser
            })
        }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, "r - " + encryptedUser, encryptedUser, "LiveConnectService", "emailBoxSuppress_ClearList") });
        return a;
    }

    async emailBoxSuppress_Add(encryptedUser: string, emailBoxSuppress: EmailBoxSuppress): Promise<SimpleResponse | void> {
        const a = await this.httpClient.post<SimpleResponse>(`${this.baseUrlEmailBox}/EmailBoxSuppress_Add`, emailBoxSuppress, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + encryptedUser
            })
        }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, "r - " + encryptedUser, encryptedUser, "LiveConnectService", "emailBoxSuppress_Add") });
        return a;
    }

    async emailBoxSuppress_Exists(encryptedUser: string, emailBoxSuppress: EmailBoxSuppress): Promise<SimpleResponse | void> {
        const a = await this.httpClient.post<SimpleResponse>(`${this.baseUrlEmailBox}/EmailBoxSuppress_Exists`, emailBoxSuppress, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + encryptedUser
            })
        }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, "r - " + encryptedUser, encryptedUser, "LiveConnectService", "emailBoxSuppress_Exists") });
        return a;
    }

    async emailBoxSuppress_Remove(encryptedUser: string, emailBoxSuppressID: number): Promise<SimpleResponse | void> {
        const a = await this.httpClient.get<SimpleResponse>(`${this.baseUrlEmailBox}/EmailBoxSuppress_Remove/${emailBoxSuppressID}`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + encryptedUser
            })
        }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, "r - " + encryptedUser, encryptedUser, "LiveConnectService", "emailBoxSuppress_Remove") });
        return a;
    }
}
